import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalle from './DetalleColaborador';
import TablaDetalleVer from './DetalleColaboradorVer';
import TablaDetalleMod from './DetalleColaboradorMod';

import {
    renderField,
    renderCurrencyFloat,
    SelectField
} from "../../Utils/renderField/renderField";

function ColaboradorForm(props) {
    const {
        modulo,
        listaTipoMO,
        titulo,
        crear,
        editar,
        registroColaborador,
        modificarColaborador,
        detalleColaborador,
        detalleColab,
        eliminarLinea,
        lectura,
        agregarLinea,
        agregarLineaNueva,
        eliminarLineaNueva
    } = props;

    let autoFocus = true;
    const estilo = {
        overflow: "auto",
        height: "300px",

    };
     
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-4'>
                                    <Field
                                        name="tipo_mdo"
                                        autoFocus={autoFocus}
                                        dato={crear === true ? 0 : lectura}
                                        options={listaTipoMO}
                                        component={SelectField}
                                        className="form-select"
                                        msj="Tipo mano de obra"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-4'>
                                    <Field
                                        name="tipo_mdo"
                                        autoFocus={autoFocus}
                                        dato={crear === true ? 0 : lectura}
                                        options={listaTipoMO}
                                        component={SelectField}
                                        className="form-select"
                                        disabled={true}
                                        msj="Tipo mano de obra"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div className='row mb-2'>
                                <div className='col-4'>
                                    <Field
                                        name="Tipo mano de obra"
                                        autoFocus={autoFocus}
                                        dato={crear === true ? 0 : lectura}
                                        options={listaTipoMO}
                                        component={SelectField}
                                        className="form-select"
                                        disabled={true}
                                        msj="Tipo"
                                    />
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div>
                                <div className='row mb-2'>
                                    <h5 className="p-2 bg-secondary title mt-1">Colaboradores</h5>
                                    <div className='col-2'>
                                        <Field
                                            name="identificadorC"
                                            placeholder="Identificador"
                                            className="form-control"
                                            component={renderField}
                                            msj="Identificador"
                                        />
                                    </div>
                                    <div className='col-8'>
                                        <Field
                                            name="nombreC"
                                            placeholder="Nombre"
                                            className="form-control"
                                            component={renderField}
                                            msj="Nombre"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="sueldoC"
                                            placeholder="Sueldo"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Sueldo"
                                        />
                                    </div>
                                </div>
                                <Contenido>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => {
                                            agregarLinea();
                                        }}
                                    >
                                        Agregar
                                    </button>
                                </Contenido>
                            </div>
                        }
                        
                        {crear === false && editar === true &&
                            <div>
                                <div className='row mb-2'>
                                    <h5 className="p-2 bg-secondary title mt-1">Colaboradores</h5>
                                    <div className='col-2'>
                                        <Field
                                            name="identificadorC"
                                            placeholder="Identificador"
                                            className="form-control"
                                            component={renderField}
                                            msj="Identificador"
                                        />
                                    </div>
                                    <div className='col-8'>
                                        <Field
                                            name="nombreC"
                                            placeholder="Nombre"
                                            className="form-control"
                                            component={renderField}
                                            msj="Nombre"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="sueldoC"
                                            placeholder="Sueldo"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Sueldo"
                                        />
                                    </div>
                                </div>
                                <Contenido>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => {
                                            agregarLineaNueva();
                                        }}
                                    >
                                        Agregar
                                    </button>
                                </Contenido>
                            </div>
                        }
                        
                        {crear === true && editar === false &&
                            <div style={estilo}>
                                <TablaDetalle
                                    detalle={detalleColaborador}
                                    eliminarLinea={eliminarLinea}
                                />
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div style={estilo}>
                                <TablaDetalleMod
                                    detalle={detalleColab}
                                    eliminarLinea={eliminarLineaNueva}
                                />
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Colaboradores</h5>
                                <div style={estilo}>
                                    <TablaDetalleVer
                                        detalle={detalleColab}
                                    />
                                </div>
                            </div>
                        }
                        <br />
                        <div className='d-flex flex-row mt-3'>
                            {crear === true && editar === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => registroColaborador()}
                                >
                                    Guardar
                                </button>
                            }
                            {editar === true && crear === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => modificarColaborador()}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href={`/#/gestion_proyecto/${id_emp[5]}/colaboradores`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ColaboradorForm.propTypes = {
    crear: PropTypes.bool,
};

export default reduxForm({
    form: 'FormColaboradorProyecto',
})(ColaboradorForm);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;